import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = () => {
  const { logout, user } = useAuth0();
  const { nickname } = user || {};

  return (
    <div className="loginContainer">
      <button
        className="btn btn-danger"
        onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
        Log Out {nickname}
      </button>
    </div>
  );
};

export default LogoutButton;